/* global google */
import React, { Component } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import SearchBox from "react-google-maps/lib/components/places/SearchBox";
import _ from "lodash";
import Geocode from "react-geocode";
import api from "../api";
import axios from "axios";

const Map = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={10}
      center={props.center}
      ref={props.onMapMounted}
      onRightClick={props.onMapClick}
      onDblClick={props.onDblClick}
    >
      <SearchBox
        controlPosition={google.maps.ControlPosition.TOP_LEFT}
        ref={props.onSearchBoxMounted}
        onPlacesChanged={e => props.onPlacesChanged(e)}
      >
        <input
          type="text"
          placeholder="Buscar dirección aquí"
          disabled={props.disabled}
          value={props.value}
          style={{
            boxSizing: `border-box`,
            border: `1px solid transparent`,
            width: `240px`,
            height: `32px`,
            marginTop: `27px`,
            padding: `0 12px`,
            borderRadius: `3px`,
            boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
            fontSize: `14px`,
            outline: `none`,
            textOverflow: `ellipses`
          }}
        />
      </SearchBox>
      {props.marks.map((mark, index) => {
        var src =
          mark.is_official === 1
            ? require("../../../images/marker_official.png")
            : mark.favorite === 1
            ? require("../../../images/marker_favorite.png")
            : mark.contact_location === 1
            ? require("../../../images/marker_user.png")
            : require("../../../images/marker.png");
        var icon = new window.google.maps.MarkerImage(
          src,
          null /* size is determined at runtime */,
          null /* origin is 0,0 */,
          null /* anchor is bottom center of the scaled image */,
          new window.google.maps.Size(30, 30)
        );
        return (
          <Marker
            key={index}
            position={mark}
            onClick={e => props.handleToogleMarker(index)}
            icon={icon}
            radius={10000}
            options={{
              strokeColor: "#66009a",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: `#66009a`,
              fillOpacity: 0.35,
              zIndex: 1500
            }}
          >
            {mark.open && (
              <InfoWindow onCloseClick={e => props.handleToogleMarker(index)}>
                <span>{mark.business_name}</span>
              </InfoWindow>
            )}
          </Marker>
        );
      })}
    </GoogleMap>
  ))
);

class googleMaps extends Component {
  constructor(props) {
    super(props);
    var lng = parseFloat(process.env.REACT_APP_AUTOCORP_LONG);
    var lat = parseFloat(process.env.REACT_APP_AUTOCORP_LAT);
    var center = { lat: lat, lng: lng };
    this.state = {
      marks: [],
      markers: [],
      providers: [],
      center: { center }
    };
    this.onSearch = this.onSearch.bind(this);
    this.handleToogleMarker = this.handleToogleMarker.bind(this);
  }

  componentDidMount() {
    let updated = false;
    var markers = [];
    var places = this.props.places;
    if (
      this.props.contact_location.lat !== null &&
      this.props.contact_location.lat !== "" &&
      this.props.contact_location.lng !== null &&
      this.props.contact_location.lng !== ""
    ) {
      var center = {
        lat: parseFloat(this.props.contact_location.lat),
        lng: parseFloat(this.props.contact_location.lng)
      };
    } else {
      var lng = parseFloat(process.env.REACT_APP_AUTOCORP_LONG);
      var lat = parseFloat(process.env.REACT_APP_AUTOCORP_LAT);
      var center = { lat: lat, lng: lng };
    }
    this.setState({ center: center });

    this.props.providers.map((val, idx) => {
      var marker = {
        lat: parseFloat(val.lat),
        lng: parseFloat(val.long),
        is_official: val.is_official,
        business_name: val.business_name
      };
      markers.push(marker);
    });
    if (this.props.desired_zone && this.props.desired_zone.lat !== undefined) {
      var marker = {
        lat: parseFloat(this.props.desired_zone.lat),
        lng: parseFloat(this.props.desired_zone.lng),
        business_name: "Zona deseada",
        contact_location: 1,
        open: true
      };
      markers.push(marker);
    }

    if (
      this.props.contact_location.lat !== "" &&
      this.props.contact_location.lat !== undefined
    ) {
      var marker = {
        lat: parseFloat(this.props.contact_location.lat),
        lng: parseFloat(this.props.contact_location.lng),
        contact_location: 1,
        business_name: "Ubicación contacto"
      };
      markers.push(marker);
    }

    this.setState({
      markers: markers
    });

    /*      this.props.places.map((val, idx) => {
        if (val[0].formatted_address !== undefined){
          marks.push(val[0].geometry.location)
        } else {
            let address = {}
            updated = true
            Geocode.setApiKey("AIzaSyBdMpcA_SncYL2mPdjNtZy4_MrFskiWPVY");
            Geocode.setLanguage("es");
            Geocode.setRegion("es");
            Geocode.enableDebug();
            Geocode.fromLatLng(val[0].geometry.location.lat, val[0].geometry.location.lng).then(
                    response => {
                      address = response;
                      if ((address.results[0].types.includes('street_address'))){
                        var new_address = []
                        new_address.push(address.results[0])
                        places[idx] = new_address
                      }
                    },
                    error => {
                      console.error(error);
                    }
                  );          
        }
      })

      const nextMarkers = this.props.places.map(place => ({
        position: place[0].geometry.location,
      }));

      const nextCenter = _.get(nextMarkers, '0.position', this.state.center);
      this.setState({marks: marks, markers: this.props.places, providers: this.props.providers })*/
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.providers.length !== this.props.providers.length) {
      var markers = [];
      if (this.props.providers.length === 0) {
        markers = [];
      } else {
        this.props.providers.map((val, idx) => {
          if (val.contact.address) {
            if (val.contact.address.length > 0) {
              val.contact.address.map((val2, idx) => {
                var marker = {
                  lat: parseFloat(val2.lat),
                  lng: parseFloat(val2.long),
                  is_official: val.is_official,
                  business_name: val.business_name
                };
                markers.push(marker);
              });
            }
          }
        });
      }

      if (
        this.props.desired_zone &&
        this.props.desired_zone.lat !== undefined
      ) {
        var marker = {
          lat: parseFloat(this.props.desired_zone.lat),
          lng: parseFloat(this.props.desired_zone.lng),
          business_name: "Zona deseada",
          contact_location: 1,
          open: true
        };
        markers.push(marker);
      }
      if (
        this.props.contact_location.lat !== "" &&
        this.props.contact_location.lat !== undefined
      ) {
        var marker = {
          lat: parseFloat(this.props.contact_location.lat),
          lng: parseFloat(this.props.contact_location.lng),
          business_name: "Ubicación contacto",
          contact_location: 1,
          open: true
        };
        markers.push(marker);
      }
      this.setState({ markers: markers });
    }
  }

  handleToogleMarker(index) {
    var markers = this.state.markers;
    if (markers[index]["open"] !== undefined) {
      markers[index]["open"] = !markers[index]["open"];
    } else {
      markers[index]["open"] = true;
    }
    this.setState({ markers });
  }

  onSearch(e) {
    this.setState({ address_search: e.target.value });
  }

  onMapChanged = async props => {
    var places = this.state.searchBox.getPlaces();
    const bounds = new google.maps.LatLngBounds();

    places.forEach(place => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });

    const nextMarkers = places.map(place => ({
      position: place.geometry.location
    }));

    const nextCenter = _.get(nextMarkers, "0.position", this.state.center);

    const token = localStorage.getItem("userToken");
    var new_center = { lat: nextCenter.lat(), lng: nextCenter.lng() };
    var providers_makers = await axios
      .get(
        api
          .providers()
          .latlng(
            nextCenter.lng(),
            nextCenter.lat(),
            "",
            0,
            0,
            0,
            0,
            this.props.plate
          ),
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(response => {
        return response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    var markers = [];
    providers_makers.map((val, idx) => {
      var marker = {
        lat: parseFloat(val.lat),
        lng: parseFloat(val.long),
        is_official: val.is_official,
        business_name: val.business_name
      };
      markers.push(marker);
    });

    if (
      this.props.contact_location.lat !== "" &&
      this.props.contact_location.lat !== undefined
    ) {
      var marker = {
        lat: parseFloat(this.props.contact_location.lat),
        lng: parseFloat(this.props.contact_location.lng),
        business_name: "Ubicación contacto",
        contact_location: 1
      };
      markers.push(marker);
    }

    this.props.onChange(providers_makers);
    this.setState({
      markers: markers,
      providers: providers_makers,
      center: new_center
    });
  };

  onSearchBoxMounted = ref => {
    this.setState({ searchBox: ref });
  };

  onMapMounted = ref => {
    this.setState({ ref: ref });
  };

  render() {
    /*        var markers = []
        if (this.props.providers.length === 0){
          markers = []
        } else {
          this.props.providers.map((val, idx)=>{
            if (val.contact.address.length > 0){
              val.contact.address.map((val2,idx)=>{
                var marker = {lat: parseFloat(val2.lat), lng: parseFloat(val2.long), is_official: val.is_official, business_name: val.business_name}
                markers.push(marker)
              })
            }
          })
        }

        if (this.props.contact_location.lat !== '' && this.props.contact_location.lat !== undefined){
          var marker = {lat: parseFloat(this.props.contact_location.lat), lng: parseFloat(this.props.contact_location.lng), business_name: 'Ubicación contacto', contact_location: 1, open: true}
          markers.push(marker)
        }
*/
    //        var markers = this.state.markers
    var google_api_key = process.env.REACT_APP_GOOGLE_KEY;

    return (
      <React.Fragment>
        {this.props.contact_location.address !== "" &&
        this.props.contact_location.address !== undefined ? (
          <React.Fragment>
            <div className="row">
              <div className="col col-sm-12">
                {this.props.contact_location.address}
              </div>
            </div>
          </React.Fragment>
        ) : (
          ""
        )}
        <div className="row">
          <div className="col col-sm-12">
            <Map
              googleMapURL={
                "https://maps.googleapis.com/maps/api/js?key=" +
                google_api_key +
                "&v=3.exp&libraries=geometry,drawing,places"
              }
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div style={{ height: `400px` }} />}
              mapElement={<div style={{ height: `100%` }} />}
              marks={this.state.markers}
              center={this.state.center}
              onPlacesChanged={this.onMapChanged}
              handleToogleMarker={this.handleToogleMarker}
              onSearchBoxMounted={this.onSearchBoxMounted}
              onMapMounted={this.onMapMounted}
              disabled={this.props.disabled}
              value={this.state.address_search}
              onChange={this.onSearch}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default googleMaps;
